export default __webpack_public_path__ + "media/images/borders/orange-light-border-888cd67e9492c7336476feb92f71c9ee.svg";